import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// ----------------------------------------------------------------------

export function ButtonAnimated({ text, audio, startIcon, iconAnimated, ...other }) {
  const [animations, setAnimations] = useState([]);

  const handleClick = () => {
    const newAnimation = { animation: true, id: Math.random(), x: Math.random() * 30 };
    setAnimations((prevAnimations) => [...prevAnimations, newAnimation]);
    setTimeout(
      () =>
        setAnimations((prevAnimations) =>
          prevAnimations.filter((animation) => animation.id !== newAnimation.id)
        ),
      1500
    );
  };

  return (
    <Button
      size="small"
      variant="soft"
      onClick={handleClick}
      startIcon={startIcon}
      sx={{ textWrap: 'nowrap' }}
      {...other}
    >
      {text}

      {animations.map((animation) => (
        <Box key={animation.id} className="floatUp__animation" sx={{ left: animation.x }}>
          {iconAnimated}

          {audio && <audio controls autoPlay src={audio} style={{ display: 'none' }} />}
        </Box>
      ))}
    </Button>
  );
}
